import { amountToDisplayValue, Text } from '@billy/design-system'
import { useTranslation } from 'react-i18next'

import * as Styled from './styles'

interface BookingTotalLineProps {
  baseCurrency?: string | null
  total: number | null
}

export const BookingTotalLine = ({ baseCurrency, total }: BookingTotalLineProps) => {
  const { t } = useTranslation()
  const formattedTotal = amountToDisplayValue(total || 0)

  return (
    <Styled.BookingWrapper>
      <Text weight="medium">{t('ledger.total', { baseCurrency })}</Text>
      <Text weight="medium">{formattedTotal}</Text>
    </Styled.BookingWrapper>
  )
}
